import {
  type ApiMaterialsV1MaterialProductsCreate400,
  type ApiMaterialsV1MaterialProductsUpdate400,
  ErrorResponse,
  ErrorType,
  isFieldErrorResponse,
} from 'api';
import { UseFormReturn } from 'form';

import { CreateFormValues } from '../../pages/MaterialProductCreate/MaterialProductCreate';
import { UpdateFormValues } from '../../pages/MaterialProductDetails/MaterialProductDetails';

export const handleError = (
  error: ErrorType<ErrorResponse | ApiMaterialsV1MaterialProductsCreate400 | ApiMaterialsV1MaterialProductsUpdate400>,
  setError: UseFormReturn<CreateFormValues | UpdateFormValues>['setError']
) => {
  if (isFieldErrorResponse(error)) {
    Object.keys(error.response?.data).forEach((field) => {
      const fieldName = field !== 'material_component_values' ? field : 'non_field_errors';
      setError(fieldName as keyof (CreateFormValues | UpdateFormValues), { message: error.response.data[field] });
    });
  }
};
